import {WEB_TEMPLATE_RESOURCE, CUSTOM_WEB_TEMPLATE_RESOURCE, SCROLLER_TEMPLATE_RESOURCE} from '../api/resources';
import {fetchResource} from './remote';
import { API_ROOT } from "signoxe/constants/config";
import request from 'superagent';
import { actions as notifActions } from "redux-notifications";

const { notifSend } = notifActions;


export const fetchWebAssetTemplates = fetchResource(WEB_TEMPLATE_RESOURCE);

export const fetchCustomTemplates = fetchResource(CUSTOM_WEB_TEMPLATE_RESOURCE);

export const fetchScrollerTemplates = fetchResource(SCROLLER_TEMPLATE_RESOURCE);

const getAuthTokenHeader = () => `Bearer ${localStorage.getItem("token")}`;

export const updateScrollerAsset = (id, file, twice) => (dispatch) => {
  if (!file) {
    dispatch(
      notifSend({
        message: "Error: No file selected",
        kind: "alert",
        dismissAfter: 5000,
      })
    );
    return;
  }

  const url = `${API_ROOT}scroller-assets/${id}/`;

  // Use superagent to send the data as an attachment
  request
    .put(url)
    .set("Authorization", getAuthTokenHeader())
    .accept("application/json")
    .attach("media_file", file)
    .end((err, response) => {

      if (err) {
        console.error(err);
        alert("An error occurred while sending the request.");
      } else {
       if(twice === false){
        dispatch(
          notifSend({
            message: "Asset Successfully Updated!",
            kind: "success",
            dismissAfter: 5000,
          })
        );
       }
        if (response.status === 500) {
          alert("Something went wrong");
        } else {
          console.log("Response data", response.body);
          // Handle the response data as needed
        }
      }
    });
};




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/webAssetTemplate.js